module.exports = __webpack_public_path__ + "static/ihr_Appstore_icon-afd3a39e8062abff01c8405af4e096fb.png";